<script lang="ts">
    import {
        Alert,
        Button,
        Col,
        Container,
        Modal,
        ModalBody,
        ModalFooter,
        ModalHeader,
        Row,
    } from "sveltestrap";
    import { appManager } from "../../AppManagerStore";
    import type { UserData } from "@anyways-open/identity-api-client";
    import { ModalHook } from "../../modals/ModalHook";
    
    let hook: ModalHook<UserData, "ok" | "error"> = new ModalHook<UserData, "ok" | "error">();

    let open = false;

    // hook events.
    hook.on("open", () => {
        open = true;

        userData = hook.getData();
    });
    hook.on("close", () => {
        open = false;
    });

    let name: string = "";
    let description: string = "";
    let creating = false;
    let error = "";
    let userData: UserData;

    const toggle = () => (open = !open);
    const save = async () => {
        error = "";
        if (name.trim().length === 0) {
            error = "Name not set";
            return;
        }

        creating = true;

        const accessToken = await $appManager.Authenticator.getAccessToken();
        const result = await $appManager.IdentityApi.postOrganization({
            data: {
                name: name,
                description: description,
                users: [],
                invites: []
            },
            accessToken: accessToken
        });

        if (result) {
            open = false;
        } else {
            error = "Could not create organization";
        }

        creating = false;
    };
</script>

<Modal isOpen={open} {toggle}>
    <ModalHeader {toggle}>New organization</ModalHeader>
    <ModalBody>
        <Container class="d-flex flex-column">
            <Row class="align-items-center justify-content-center gx-0">
                <Col>
                    {#if !creating}
                        <div class="mb-6">
                            <div class="form-group">
                                <label class="form-label" for="name">
                                    Name
                                </label>
                                <input
                                    type="name"
                                    class="form-control"
                                    id="name"
                                    placeholder="Name"
                                    bind:value={name} />
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="description">
                                    Description
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="description"
                                    placeholder="Description"
                                    bind:value={description} />
                            </div>

                            {#if error.length > 0}
                                <Alert class="mt-2">{error}</Alert>
                            {/if}
                        </div>
                    {:else}
                        <h1 class="mb-0 fw-bold">Thank you! 👍</h1>

                        <p class="mb-6 text-muted">
                            We've sent you an email confirmation message.
                        </p>
                    {/if}
                </Col>
            </Row>
        </Container>
    </ModalBody>
    <ModalFooter>
        <Button color="primary" on:click={async () => await save()}
            >Save</Button>
        <Button color="secondary" on:click={toggle}>Cancel</Button>
    </ModalFooter>
</Modal>
